/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  Self,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControlName,
  NgControl
} from '@angular/forms';
import { HelpModal, UlItem } from '../../../models';

@Component({
  selector: 'idp-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent
  implements OnInit, ControlValueAccessor, OnChanges, AfterViewInit
{
  @Input() addtlMaskInfo = false;
  @Input() addMargin = false;
  @Input() arrowPosition = 'right';
  @Input() bottomLabelIcon = false;
  @Input() bottomLabelText = '';
  @Input() calcEstimateBtnClicked = false;
  @Input() onNextBtnClicked = false;
  @Input() classListBottomLabel = '';
  @Input() classListTopLabel = '';
  @Input() displayFlex = false;
  @Input() error = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() helpIcon = false;
  @Input() id = 'placeholder';
  @Input() initialValueIndex!: number;
  @Input() isAbsolute = false;
  // @Input() items!: (UlItem & PassengersEntity & MedallionEntity & BrandEntity)[];
  @Input() items!: UlItem[];
  @Input() name = '';
  @Input() placeholderText = '';
  @Input() preventToUpdateItem = false;
  @Input() previousSelectedItem!: UlItem | null;
  @Input() reset = false;
  @Input() submitAttempt = false;
  @Input() transformCapitalize = false;
  @Input() topLabelText = '';
  @Input() topLabelIcon = false;
  @Input() helpModal!: HelpModal;
  @Input() topLabelSrOnly = false; // Will be passed as TRUE from component doesnt needs topLabelText
  @Input() focusRequired = false;
  @Input() selectedDropdownValue = '';
  @Input() selectedItemIndex = -1;
  @Input() disabled = false;
  @Input() setToDefaultValue = false;
  @Input() customClass = '';
  @Output() bottomLabelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() tooltipClicked: EventEmitter<string> = new EventEmitter();
  @Output() topLabelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() value: EventEmitter<UlItem> = new EventEmitter<UlItem>();
  @Output() hasFocus: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('focusElement') focusElement!: ElementRef;
  allowFocusChange = true;
  dropdownSelectedFocused = false;
  dropdownWrapperFocused = false;
  errorMessage = '';
  focused = false;
  firstKeyDown = true;
  hasValue = false;
  liFocused = false;
  keyTracker = {
    previousKey: {},
    currentKey: {},
    counter: 0
  };

  optionsLIObject!: NodeListOf<Element> | undefined;
  open = false;
  optionIndex = 0;
  optionsLIArray = [];
  selectedItem: UlItem = {
    id: '',
    value: '',
    label: '',
    secondaryIcon: '',
    additionalIcon: '',
    displayName: ''
  };

  setDropdownWrapperFocused = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  suggestions: any = [];
  // TODO : Need to work on how to handle nodesList type as it supports only if target is es6 in tsconfig
  defaultSet = false;
  private onChange!: (item: {
    id: string;
    value: string;
    label: string;
  }) => void;

  private onTouched!: () => void;

  constructor(
    private elementRef: ElementRef,
    @Optional() @Self() private ngControl: NgControl,
    @Optional() public controlName: FormControlName
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get errorState() {
    if (
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched &&
      this.submitAttempt &&
      Object.keys(this.errorMessages).length
    ) {
      this.errorMessage =
        this.errorMessages[Object.keys(this.ngControl.errors)[0]];
    }

    return (
      this.submitAttempt &&
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched
    );
  }

  ngAfterViewInit(): void {
    if (
      this.focusRequired &&
      this.selectedDropdownValue &&
      this.controlValueCheck(this.controlName) &&
      this.controlName.control.value.id === this.selectedDropdownValue
    ) {
      this.focusElement.nativeElement.focus({
        preventScroll: true
      });
      const x = window.scrollX;
      const y = window.scrollY;
      window.onscroll = function () {
        window.scrollTo(x, y);
      };
      setTimeout(() => {
        window.onscroll = function () {
          return undefined;
        };
      }, 0);
    }
  }

  ngOnInit() {
    this.setInitialValue();
    if (
      Object.keys(this.selectedItem).length ||
      this.controlValueCheck(this.controlName)
    ) {
      this.selectedItemIndex = this.getSelectedItemIndex();
      this.firstKeyDown = this.selectedItemIndex !== -1 ? false : true;
    }
    this.submitAttempt = this.calcEstimateBtnClicked
      ? this.calcEstimateBtnClicked
      : this.submitAttempt;
    this.submitAttempt = this.onNextBtnClicked
      ? this.onNextBtnClicked
      : this.submitAttempt;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.reset) {
      this.setInitialValue(true);
    } else {
      if (changes['initialValueIndex']) {
        this.initialValueIndex = changes['initialValueIndex'].currentValue;
        this.setInitialValue(
          changes['initialValueIndex'].currentValue >= 0 ? false : true
        );
      }
      if (changes?.['items']) {
        this.items = changes['items'].currentValue;
      }

      // if (Object.prototype.hasOwnProperty.call(changes, 'items')) {
      //   this.items = changes.items.currentValue;
      // }
    }
    if (this.setToDefaultValue) {
      this.setInitialValue(true);
    }
  }

  setInitialValue(reset = false) {
    if (reset) {
      this.initialValueIndex = -1;
      this.selectedItem = {};
      this.selectedItemIndex = -1;
      this.previousSelectedItem = null;
    }

    if (
      this.initialValueIndex > -1 &&
      this.items &&
      this.items[this.initialValueIndex] &&
      !this.focusRequired
    ) {
      this.setSelectedItem(this.items[this.initialValueIndex], true);
    } else {
      if (!this.placeholderText && this.items && this.items.length) {
        this.setSelectedItem(this.items[0], true);
      }
    }
  }

  toggle(event: Event, passthrough = false) {
    if (this.disabled) {
      this.close();
      return;
    }

    this.allowFocusChange = false;
    this.reset = false;
    if (!passthrough) {
      event.preventDefault();
    }

    if ((<HTMLLIElement>event.target).tagName === 'li') {
      this.open = false;
      return;
    } else {
      this.open = !this.open;
    }
    if ((<HTMLUListElement>event.target).tagName === 'UL') {
      this.open = true;
    }
    if (this.open) {
      const element = event.target as HTMLElement;
      if (element.tagName === 'svg') {
        this.dropdownSelectedFocused = true;
      } else if (element.tagName === 'DIV' || element.tagName === 'SPAN') {
        this.setDropdownWrapperFocus(event);
      } else {
        setTimeout(() => {
          element?.parentElement?.focus();
        });
      }
    }

    this.allowFocusChange = true;
  }

  setDropdownWrapperFocus(event: Event) {
    this.setDropdownWrapperFocused = true;
    const className = `ul li:nth-child(${this.selectedItemIndex + 2})`;
    if (
      event &&
      event.target &&
      (<HTMLElement>event.target).parentElement &&
      (<HTMLElement>event.target).parentElement?.querySelectorAll(className)[0]
    ) {
      (
        (event.target as HTMLElement)?.parentElement?.querySelectorAll(
          className
        )[0] as HTMLElement
      )?.focus();
    }
  }

  refocus(event: Event) {
    if (this.disabled) {
      return;
    }

    const element = event.target as HTMLElement;
    if (element.tagName === 'svg') {
      this.dropdownSelectedFocused = true;
      this.setDropdownWrapperFocus(event);
    } else if (
      element.tagName === 'DIV' ||
      element.tagName === 'SPAN' ||
      element.tagName === 'LI' ||
      element.tagName === 'SECTION'
    ) {
      this.setDropdownWrapperFocused = true;
    } else {
      setTimeout(() => {
        element?.parentElement?.focus();
      });
    }
  }

  close() {
    this.open = false;
  }

  selected(event: Event) {
    if (this.preventToUpdateItem) {
      if (this.previousSelectedItem) {
        this.setSelectedItem(this.previousSelectedItem);
      } else {
        this.setSelectedItem(this.items[this.initialValueIndex]);
        this.value.emit(event);
      }
    } else {
      event.preventDefault();
      event.stopPropagation();
      this.setSelectedItem(
        {
          label: (<HTMLElement>event.target).dataset['label'],
          value: (<HTMLElement>event.target).dataset['value']
        },
        false,
        true
      );
      this.firstKeyDown = false;
      this.open = false;
    }
  }

  tabSelection(event: KeyboardEvent) {
    if (event.code === 'Tab' || (event.shiftKey && event.keyCode === 9)) {
      if (Object.keys(this.selectedItem).length > 0 && this.focusRequired) {
        this.value.emit({
          id: this.id,
          value: this.selectedItem.value,
          label: this.selectedItem.label,
          defaultValueSet: this.defaultSet
        });
      }
    }
  }

  setSelectedItem(item: UlItem, defaultSet = false, isEnter = false) {
    if (item) {
      this.selectedItem = item;
      this.selectedItemIndex = this.getCurrentSelectedItemIndex();
      if (isEnter || !this.focusRequired) {
        this.value.emit({
          id: this.id,
          value: item.value,
          label: item.label,
          defaultValueSet: defaultSet,
          index: this.selectedItemIndex
        });
      }
      if (this.onChange) {
        this.onChange({
          id: this.id,
          value: item.value ?? '',
          label: item.label ?? ''
        });
      }
    } else {
      this.hasValue = false;
    }
    this.reset = false;
  }

  getCurrentSelectedItemIndex(): number {
    let selectedItemIndex = 0;
    if (this.selectedItem && this.items && this.items.length) {
      this.items.forEach((item, index) => {
        if (
          item.label === this.selectedItem.label &&
          item.value === this.selectedItem.value
        ) {
          selectedItemIndex = index;
        }
      });
    }
    return selectedItemIndex;
  }

  getSelectedItemIndex(): number {
    let selectedItemIndex = -1;
    if (
      this.controlValueCheck(this.controlName) &&
      this.items &&
      this.items.length
    ) {
      this.items.findIndex((item, index) => {
        if (item.label === this.controlName.control.value.label) {
          selectedItemIndex = index;
        }
      });
    }
    return selectedItemIndex;
  }

  controlValueCheck(controlName: FormControlName): boolean {
    return controlName && controlName.control && controlName.control.value;
  }

  updateSelection(event: Event, direction: string) {
    if (this.disabled) {
      this.close();
      return;
    }
    let selectedItemIndex: number;
    if (this.focusRequired) {
      selectedItemIndex = this.selectedItemIndex;
    } else {
      selectedItemIndex = this.getCurrentSelectedItemIndex();
    }
    event.preventDefault();
    event.stopPropagation();
    this.allowFocusChange = false;
    if (direction === 'up') {
      this.selectPrevious(event, selectedItemIndex);
    }
    if (direction === 'down') {
      this.selectNext(event, selectedItemIndex);
    }
    if (direction === 'characters') {
      this.selectCharacters(event);
    }
    this.hasValue = true;
    this.allowFocusChange = true;
    this.firstKeyDown = false;
  }

  selectPrevious(event: Event, selectedItemIndex: number): void {
    if (
      (this.firstKeyDown && this.placeholderText) ||
      selectedItemIndex === 0
    ) {
      this.setSelectedItem(this.items[this.items.length - 1], false, true);
      (
        (<HTMLElement>event.target)?.parentElement?.querySelectorAll(
          'ul li:last-child'
        )[0] as HTMLElement
      ).focus();
    } else {
      this.setSelectedItem(this.items[selectedItemIndex - 1], false, true);
      (
        (<HTMLElement>event.target)?.parentElement?.querySelectorAll(
          'ul li:nth-child(' + selectedItemIndex + ')'
        )[0] as HTMLElement
      ).focus();
    }
  }

  selectNext(event: Event, selectedItemIndex: number): void {
    if (
      (this.firstKeyDown && this.placeholderText) ||
      selectedItemIndex === this.items.length - 1
    ) {
      this.setSelectedItem(this.items[0], false, true);
      (
        (<HTMLLIElement>event.target)?.parentElement?.querySelectorAll(
          'ul li:first-child'
        )[0] as HTMLElement
      ).focus();
    } else {
      this.setSelectedItem(this.items[selectedItemIndex + 1], false, true);
      const className = `ul li:nth-child(${selectedItemIndex + 2})`;
      (
        (<HTMLLIElement>event.target)?.parentElement?.querySelectorAll(
          className
        )[0] as HTMLElement
      )?.focus();
    }
  }

  selectCharacters(event: Event): void {
    this.suggestions = Array.prototype.slice
      .call(
        (<HTMLLIElement>event.target).parentElement?.querySelectorAll('ul li')
      )
      .filter((item) => {
        return (
          item.dataset.label
            // the attribute value can contain leading/trailing white spaces
            .trim()
            .charAt(0)
            .toLowerCase()
            .indexOf((<KeyboardEvent>event).key.toLowerCase()) > -1
        );
      });
    this.getSuggestions(event);
  }

  getSuggestions(event: Event) {
    this.getKeyTracker((<KeyboardEvent>event).key);
    if (this.suggestions.length > 0) {
      // execute only if match found
      if (this.keyTracker.counter === 0) {
        this.optionIndex = 0;
      } else if (this.optionIndex + 1 === this.suggestions.length) {
        this.optionIndex = 0;
      } else {
        this.optionIndex++;
      }
      const currentSelectedIndex =
        this.suggestions[this.optionIndex].attributes['data'].value;
      const className = `ul li:nth-child(${Number(currentSelectedIndex) + 1})`;
      this.setSelectedItem(this.items[currentSelectedIndex]);
      (
        (<HTMLLIElement>event.target)?.parentElement?.querySelectorAll(
          className
        )[0] as HTMLElement
      ).focus();
    } else {
      /**
       * On pressing spacebar on keyboard,
       * clossed dropdown will open, if there are no suggestions
       */
      if (
        event instanceof KeyboardEvent &&
        (event.key === ' ' || event.keyCode === 32) &&
        !this.open
      )
        this.toggle(event);
    }
  }

  getKeyTracker(key: string) {
    this.keyTracker.currentKey = key;
    if (this.keyTracker.previousKey === this.keyTracker.currentKey) {
      this.keyTracker.counter++;
    } else {
      this.keyTracker.counter = 0;
      this.keyTracker.previousKey = key;
    }
  }

  liChangeFocus(focused: boolean) {
    if (this.allowFocusChange) {
      this.liFocused = focused;
    }
  }

  dropdownWrapperChangeFocused(focused: boolean) {
    if (this.allowFocusChange) {
      this.dropdownWrapperFocused = focused;
      this.hasFocus.emit(focused);
    }
  }

  checkFocused() {
    if (!this.liFocused && !this.dropdownWrapperFocused) {
      this.focused = false;
      this.close();
      if (this.onTouched) {
        this.onTouched();
      }
    } else {
      this.focused = true;
    }
  }

  notify(level: string) {
    if (level === 'top') {
      this.topLabelClicked.emit(true);
    } else {
      this.bottomLabelClicked.emit(true);
    }
  }

  iconClicked() {
    this.tooltipClicked.emit(this.id);
  }

  /*
   * Adds generic feature to patchValue/setValue for dropdown to convert string value to equivalent UlItem object
   * form.patchValue('US') => selectedItem = {'value' : 'US', 'label' : 'United States'} and so on..
   * This label would then be displayed in the dropdown component HTML.
   *     <span role="textbox"
   *         [attr.aria-label]="selectedItem ? selectedItem?.label : placeholderText"
   *         aria-hidden="true">{{ selectedItem ? selectedItem?.label : placeholderText }}
   *     </span>
   */

  writeValue(obj: UlItem & string) {
    if (obj) {
      if (typeof obj === 'string' && this.items && this.items.length) {
        this.selectedItem = this.getSelectedItem(obj);
      } else {
        this.selectedItem = obj;
      }
    } else {
      this.setInitialValue(true);
    }
  }

  getSelectedItem(value: string): UlItem {
    return this.items.find(
      (item) => item?.value?.toLowerCase() === value.toLowerCase()
    ) as UlItem;
  }

  registerOnChange(
    fn: (item: { id: string; value: string; label: string }) => void
  ) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.allowFocusChange = !isDisabled;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target) && this.open) {
      this.open = false;
    }
  }

  /** Method to set screen reader text depending on selected value */
  setScreenReaderText(): string {
    let text = '';
    if (this.selectedItem && Object.keys(this.selectedItem).length) {
      text = this.appendUnavailableText(this.selectedItem.label);
    } else {
      text = this.appendUnavailableText(this.placeholderText);
    }
    return text;
  }

  /** Method appends 'unavailable' text to the screen reader text if the selected item label is '--' */
  appendUnavailableText(label: string | undefined): string {
    if (!label || (label && label.length === 0)) {
      return '';
    }
    return label === '--' ? label + '  unavailable' : label;
  }

  trackById(index: number, item: UlItem): string {
    return item?.id || index.toString();
  }
}
